/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValidatorDto } from '../models/ValidatorDto';
import type { ValidatorEditDto } from '../models/ValidatorEditDto';
import type { ValidatorFilterResponseDto } from '../models/ValidatorFilterResponseDto';
import type { ValidatorResponseDto } from '../models/ValidatorResponseDto';
import type { WalletUserResponseDto } from '../models/WalletUserResponseDto';
import type { WalletUserUpdateDto } from '../models/WalletUserUpdateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValidatorControllerService {

    /**
     * @param from
     * @param status
     * @param limit
     * @param name
     * @returns ValidatorFilterResponseDto OK
     * @throws ApiError
     */
    public static listValidators(
        from?: number,
        status?: 'COMPLETED' | 'PENDING' | 'RUNNING',
        limit?: number,
        name?: string,
    ): CancelablePromise<ValidatorFilterResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validators',
            query: {
                'from': from,
                'status': status,
                'limit': limit,
                'name': name,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateValidator(
        requestBody: ValidatorEditDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/validators',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns ValidatorResponseDto Created
     * @throws ApiError
     */
    public static createValidator(
        requestBody: ValidatorDto,
    ): CancelablePromise<ValidatorResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/validators',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns ValidatorResponseDto OK
     * @throws ApiError
     */
    public static getValidator(
        name: string,
    ): CancelablePromise<ValidatorResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validators/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param deleteResources
     * @returns void
     * @throws ApiError
     */
    public static deleteValidator(
        name: string,
        deleteResources: boolean = true,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/validators/{name}',
            path: {
                'name': name,
            },
            query: {
                'deleteResources': deleteResources,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns WalletUserResponseDto OK
     * @throws ApiError
     */
    public static changeWalletUser(
        name: string,
        requestBody: WalletUserUpdateDto,
    ): CancelablePromise<WalletUserResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/validators/{name}/wallet-user',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
